import { render, staticRenderFns } from "./CancelCard.vue?vue&type=template&id=468cab90&scoped=true"
import script from "./CancelCard.vue?vue&type=script&lang=js"
export * from "./CancelCard.vue?vue&type=script&lang=js"
import style0 from "./CancelCard.vue?vue&type=style&index=0&id=468cab90&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468cab90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('468cab90')) {
      api.createRecord('468cab90', component.options)
    } else {
      api.reload('468cab90', component.options)
    }
    module.hot.accept("./CancelCard.vue?vue&type=template&id=468cab90&scoped=true", function () {
      api.rerender('468cab90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/cardHandling/components/CancelCard.vue"
export default component.exports